import { bootstrapApplication } from '@angular/platform-browser';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { SERVICE_CONSTANTS } from 'app/services/service.constants';

// Register the Portuguese locale (includes Brazilian formatting)
registerLocaleData(localePt);

bootstrapApplication(AppComponent, appConfig)
    .catch(err => console.error(err));

// Register and setup service worker after app bootstrap
if ('serviceWorker' in navigator) {
  // Track whether a SW controller already exists (i.e., not the first visit)
  const hadController = !!navigator.serviceWorker.controller;

  navigator.serviceWorker.register('/sw.js')
    .then((registration) => {
      console.log('Service Worker registered successfully');
      setupServiceWorkerListeners(hadController);
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
} else {
  console.warn('Service Worker not supported');
}

// Service Worker listeners setup
function setupServiceWorkerListeners(hadController: boolean): void {
  // Listen for service worker messages (primary update mechanism)
  navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
    // Handle push notifications
    if (event.data.type === SERVICE_CONSTANTS.EVENTS.PUSH_NOTIFICATION_RECEIVED) {
      // Dispatch custom event that services can listen to
      window.dispatchEvent(new CustomEvent(SERVICE_CONSTANTS.EVENTS.SW_PUSH_NOTIFICATION, {
        detail: event.data.data
      }));
    }

    // Handle SW updates
    if (event.data.type === SERVICE_CONSTANTS.EVENTS.SW_UPDATED) {
      console.log('Service worker updated message received');
      // Dispatch custom event that services can listen to
      window.dispatchEvent(new CustomEvent(SERVICE_CONSTANTS.EVENTS.SW_UPDATED_CUSTOM));
    }
  });

  // Listen for controller changes (fallback mechanism)
  // Skip on first visit — no previous controller means this is the initial SW install, not an update
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!hadController) {
      console.log('Service worker installed for the first time — skipping update notification');
      hadController = true;
      return;
    }
    console.log('Service worker controller changed - new SW is active');
    window.dispatchEvent(new CustomEvent(SERVICE_CONSTANTS.EVENTS.SW_UPDATED_CUSTOM));
  });

  console.log('Service Worker listeners initialized');
}
